import { Routes } from '@angular/router';

import { IframeModeComponent } from '@components/app/iframe-mode';
import { LoginComponent } from '@components/app/login';
import { NoContentComponent } from '@components/app/no-content/no-content';
import { DefaultLayoutComponent } from '@containers/layouts/default/default.component';
import { ExtraLayoutContainerComponent } from '@containers/layouts/extra/extra.container';
import { SitesGuard } from '@shared/guards/site-guard/sites.guard';
import { TranslationGuard } from '@shared/guards/translation-guard/translation.guard';
import { AuthGuard } from '@shared/helpers/auth-guard';

import { IFRAME_MODE, LOGIN_ROUTE, REPORTS_ROOT_ROUTE, ROOT_ROUTE } from './routes';

export * from './routes';

export const ROUTES: Routes = [
    {
        path: ROOT_ROUTE,
        redirectTo: `/${LOGIN_ROUTE}`,
        pathMatch: 'full',
    },
    {
        path: LOGIN_ROUTE,
        component: ExtraLayoutContainerComponent,
        children: [{ path: '', component: LoginComponent }],
    },
    {
        path: IFRAME_MODE,
        component: IframeModeComponent,
    },
    {
        path: REPORTS_ROOT_ROUTE,
        canActivate: [AuthGuard, SitesGuard, TranslationGuard],
        component: DefaultLayoutComponent,
        loadChildren: () => import('./containers/reports/reports.module').then((m) => m.ReportsModule),
    },
    { path: '**', component: NoContentComponent },
];
